/**
 * DaySheet — bottom sheet for one day (S7), tapped from the calendar.
 *
 * Reads straight from the day entry the /history month payload already
 * returned — it makes NO extra request. GPS is deliberately never shown.
 *
 * Props:
 *   day      the day entry object from /history:
 *            { date, day, weekday, status, check_in, check_out, worked_hm,
 *              branch, late, late_min, early, early_min }
 *   onClose  fn — dismiss (tap scrim / grab / BackButton)
 */
import { T, MONTH_UZ, hhmm } from '../lib/i18n.js';

const STATUS_PILL = {
  present: { cls: 'in', bg: 'var(--ok)', label: T.day_status_present },
  open: { cls: 'in', bg: 'var(--warn)', label: T.day_status_open },
  absent: { cls: 'wait', bg: 'var(--bad)', label: T.day_status_absent },
  rest: { cls: 'wait', bg: 'var(--grey-ink)', label: T.day_status_rest },
};

/** '2026-07-05' + 'shanba' -> '05-iyul, shanba' */
function dayHeader(day) {
  const parts = (day.date || '').split('-');
  const dd = parts[2] || String(day.day || '');
  const mi = parseInt(parts[1], 10);
  const month = MONTH_UZ[mi] ? MONTH_UZ[mi].toLowerCase() : '';
  return `${dd}-${month}, ${day.weekday || ''}`;
}

export default function DaySheet({ day, onClose }) {
  if (!day) return null;
  const pill = STATUS_PILL[day.status] || STATUS_PILL.rest;

  return (
    <>
      <div className="scrim" onClick={onClose} />
      <div className="sheet" role="dialog" aria-modal="true">
        <div className="grab" onClick={onClose} />
        <div className="dh">{dayHeader(day)}</div>

        <div className="rw">
          <span className="l">{T.label_checkin}</span>
          <span className="r">
            {hhmm(day.check_in) || '—'}
            {day.late ? (
              <span className="flag">
                {T.day_late} {day.late_min} {T.unit_min}
              </span>
            ) : null}
          </span>
        </div>

        <div className="rw">
          <span className="l">{T.label_checkout}</span>
          <span className="r">
            {hhmm(day.check_out) || '—'}
            {day.early ? (
              <span className="flag">
                {T.day_early} {day.early_min} {T.unit_min}
              </span>
            ) : null}
          </span>
        </div>

        <div className="rw jami">
          <span className="l">{T.label_total}</span>
          <span className="r">{day.worked_hm || '—'}</span>
        </div>

        {day.branch ? (
          <div className="rw">
            <span className="l">{T.label_branch}</span>
            <span className="r" style={{ fontWeight: 600 }}>{day.branch}</span>
          </div>
        ) : null}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
          <span className={`st-pill ${pill.cls}`} style={{ background: pill.bg }}>
            {pill.label}
          </span>
        </div>
      </div>
    </>
  );
}
